$(document).on("turbo:load", function () {
  // Api credentials
  let apiCredentialForm = new APICredentialForm();
  apiCredentialForm.init();
});
